export const isAllow = (permission, permissions) => {
  return false
}

export default {
  isAllow,
}
